import { addDays, format } from "date-fns";
import { HEALTHCARE_INDUSTRY } from "../../jobs/helpers/jobIndustries";
import { HR_ALL_MODE, HR_HEALTHCARE_MODE } from "../../modes/constants";

export const INITIAL_DATA_WITH_FALSY_ITEMS = {
  isStandardService: true,
  isExpressService: false,
  isTemporaryShiftService: false,
  isSocialMediaPromotion: false,
  isFeaturedPromotion: false,
  isSponsoredPromotion: false,
};

export function setAdditionalJobData({
  additionalPromotions,
  additionalPromotionServices,
  isExpressService = false,
  isTemporaryShiftService = false,
  initialJobData = {
    isStandardService: true,
    isExpressService,
    isTemporaryShiftService,
  },
  industry,
}) {
  let additionalJobData = initialJobData;
  if (isExpressService) {
    additionalJobData = {
      ...additionalJobData,
      isStandardService: false,
      isExpressService: true,
    };
  }
  if (isTemporaryShiftService) {
    additionalJobData = {
      ...additionalJobData,
      isStandardService: false,
      isTemporaryShiftService: true,
    };
  }
  if (additionalPromotions.includes(additionalPromotionServices.socialMedia)) {
    additionalJobData = { ...additionalJobData, isSocialMediaPromotion: true };
  }
  if (
    !isTemporaryShiftService &&
    additionalPromotions.includes(additionalPromotionServices.featuredPost)
  ) {
    additionalJobData = { ...additionalJobData, isFeaturedPromotion: true };
  }
  if (
    !isTemporaryShiftService &&
    additionalPromotions.includes(additionalPromotionServices.sponsoredPost)
  ) {
    additionalJobData = { ...additionalJobData, isSponsoredPromotion: true };
  }

  if (industry === HEALTHCARE_INDUSTRY) {
    additionalJobData = { ...additionalJobData, mode: HR_HEALTHCARE_MODE };
  } else {
    additionalJobData = { ...additionalJobData, mode: HR_ALL_MODE };
  }

  return additionalJobData;
}

export function getAdditionalPromotedDates({
  publishedDate,
  promotionDuration,
}) {
  let datesFor = [format(publishedDate, "dd/MM/yyyy")];
  for (let i = 1; i <= promotionDuration; i++) {
    datesFor.push(format(addDays(publishedDate, i), "dd/MM/yyyy"));
  }

  return {
    datesFor: datesFor,
    expiring: new Date(
      addDays(new Date(), promotionDuration).setHours(23, 59, 59)
    ),
  };
}
